import React, { useContext } from 'react';
import styles from '../../../Styles/Login.Header.module.scss';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import { GetCompanyInformation } from 'Routes/Protected/AboutUs/Adapters/GetCompanyInformation';
import RASHEN from 'Assets/images/RASHEN.png';

const MainHeader = () => {
  const appConfig = useContext(GlobalContext)?.appConfig;

  const [CorpData, setCorpData] = React.useState({});
  React.useEffect(() => {
    GetCompanyInformation(false, setCorpData);
  }, []);

  return (
    <div className={styles.topLogo}>
      <div
        className={styles.logoContainer}
        onClick={() =>
          window.open(
            CorpData?.WASite || 'https://rashensystem.com/'
          )
        }
        style={{ cursor: 'pointer' }}
      >
        <img
          src={
            appConfig?.filter(
              (fl) => fl?.Key === 'webAppLogo'
            )[0]?.Value || RASHEN
          }
          alt={
            appConfig?.filter(
              (fl) => fl?.Key === 'webAppNameMarkaz'
            )[0]?.Value
          }
        />
      </div>
    </div>
  );
};

export default MainHeader;
